import { Card, Grid, Box, Chip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { workshopCardStyle } from "../../../shared/styles/cardStyles";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import Rating from "../../../shared/components/Rating";
import Reviews from "../../workshop/components/Reviews";
import { useGetRatingsQuery } from "../../../app/store/api/workshopApi";

export default function WorkshopCard({ workshop }) {

    const { t } = useTranslation();

    const [ open, setOpen ] = useState();
    const {data:ratingsData} = useGetRatingsQuery({ workshopId: workshop.id });
    const {ratings} = ratingsData || {};

    useEffect(() => {
        const now = dayjs();
        const dayName = now.format('dddd');
        const time = now.format('HH:mm');
        
        const todaysHours = workshop.openingHours[dayName.toLowerCase()];
        
        if (todaysHours && todaysHours.open !== null && todaysHours.close !== null) {
            const currentHour = parseInt(time.split(':')[0]);
            const currentMinute = parseInt(time.split(':')[1]);
            const currentTimeInMinutes = currentHour * 60 + currentMinute;
            
            // Parse opening time (e.g., "07:30" -> 7 * 60 + 30 = 450 minutes)
            const [openHour, openMinute] = todaysHours.open.split(':').map(Number);
            const openTimeInMinutes = openHour * 60 + openMinute;
            
            // Parse closing time (e.g., "17:00" -> 17 * 60 + 0 = 1020 minutes)
            const [closeHour, closeMinute] = todaysHours.close.split(':').map(Number);
            const closeTimeInMinutes = closeHour * 60 + closeMinute;
            
            // Check if current time is between opening and closing times
            const isOpen = currentTimeInMinutes >= openTimeInMinutes && currentTimeInMinutes < closeTimeInMinutes;
            
            setOpen(isOpen);
        } else {
            // No opening hours for today or closed day, consider closed
            setOpen(false);
        }
    }, [workshop.openingHours]);
    
    return (
        <Grid size={{xs: 12, sm: 4, md: 4, lg: 4}} sx={{ padding: 0,  }} >
            <Card className="workshop-card-v2" sx={{...workshopCardStyle, height: '100%'}}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px", marginBottom: "4px" }}>
                    <Typography variant='subtitle1' sx={{ fontWeight: 700, fontSize: "0.95rem", lineHeight: 1.2 }}>
                    {workshop.name}
                    </Typography>
                    <Box sx={{ borderRadius: '4px' }}>
                        <Chip size="small" label={open ? t('workshopCard.open') : t('workshopCard.closed')} color={open ? 'success' : 'error'} />
                    </Box>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                    <Box sx={{ display: "flex", flexDirection: "column", flex: 1, paddingRight: "8px" }}>
                        <Typography variant='caption' color='text.secondary' sx={{ mt: 0.5, display: "block" }}>
                            {workshop.address}
                        </Typography>        
                        <Box sx={{ display: "flex", alignItems: "center", marginTop: "4px", gap: "8px", flexWrap: "wrap" }}>
                            <Rating rating={ratings} />
                            <Reviews workshopId={workshop.id} />
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ marginTop: "4px",display: "flex",flexDirection: "column",alignItems: "flex-start",height:"60%",overflow:"auto" }} onClick={(e) => e.stopPropagation()}>
                    <Typography variant="body1" component="p">
                        {workshop?.description && workshop.description.length > 200 ? `${workshop.description.substring(0, 200)}...` : workshop.description}
                    </Typography>
                </Box>
            </Card>
        </Grid>
    );
}   